import { Box } from '@mui/material';
import type { useMediaUpload } from '@/hooks/use-media-upload.ts';
import MediaUploadPreflightSummary from '@/components/media/media-upload-preflight-summary.tsx';
import MediaUploadProgress from '@/components/media/media-upload-progress.tsx';

type MediaUploadState = ReturnType<typeof useMediaUpload>;

export default function MediaUploadFeedback({ mediaUpload }: { mediaUpload: MediaUploadState }) {
  if (!mediaUpload.isFeedbackVisible) {
    return null;
  }

  const showPreflight = mediaUpload.preflight && mediaUpload.fileSizeBytes != null && mediaUpload.fileName != null;
  const preflightBlocked = mediaUpload.preflight != null && !mediaUpload.preflight.allowed;
  const preflightFileName = mediaUpload.fileName;
  const preflightFileSizeBytes = mediaUpload.fileSizeBytes;
  const preflight = mediaUpload.preflight;

  return (
    <Box sx={{ width: '100%' }}>
      {showPreflight && preflightFileName != null && preflightFileSizeBytes != null && preflight != null ? (
        <MediaUploadPreflightSummary
          fileName={preflightFileName}
          fileSizeBytes={preflightFileSizeBytes}
          preflight={preflight}
          onDismiss={preflightBlocked ? () => void mediaUpload.cancel() : undefined}
        />
      ) : null}
      {!preflightBlocked &&
        mediaUpload.uploadItems.map((item, index) => (
          <MediaUploadProgress
            key={`${item.fileName}-${index}`}
            fileName={item.fileName}
            fileSizeBytes={item.fileSizeBytes}
            progress={item.progress}
            status={item.status}
            onCancel={index === 0 ? () => void mediaUpload.cancel() : undefined}
          />
        ))}
    </Box>
  );
}
